<!-- .block-features -->
<div *ngIf="options" class="block block-features block-features--layout--{{options.layout }}">
    <div class="block-features__list">
        <ng-container *ngFor="let feature of options.features;let i = index">
            <div *ngIf="i>0" class="block-features__divider"></div>
            <div class="block-features__item">
                <div class="block-features__icon">
                    <mat-icon>{{feature.icon}}</mat-icon>
                </div>
                <div class="block-features__content">
                    <div class="block-features__title">{{translateHelper.localize(feature.header)}}</div>
                    <div class="block-features__subtitle">{{translateHelper.localize(feature.body)}}</div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<!-- .block-features / end -->
